import "core-js/modules/es6.number.constructor";
export default {
  data: function data() {
    return {
      isShowAppletTip: false,
      lastLoginTime: localStorage.getItem('lastLoginTime') || ''
    };
  },
  methods: {
    close: function close() {
      this.isShowAppletTip = false;
    },
    showApplet: function showApplet() {
      var _this = this;
      if (this.lastLoginTime) {
        var isSameDay = this.isSameDay(this.lastLoginTime);
        if (isSameDay) {
          this.isShowAppletTip = false;
        } else {
          localStorage.setItem('lastLoginTime', new Date().getTime());
          this.isShowAppletTip = true;
          setTimeout(function () {
            _this.isShowAppletTip = false;
          }, 5000);
        }
      } else {
        localStorage.setItem('lastLoginTime', new Date().getTime());
        this.isShowAppletTip = true;
        setTimeout(function () {
          _this.isShowAppletTip = false;
        }, 5000);
      }
    },
    isSameDay: function isSameDay(time) {
      return new Date(Number(time)).toDateString() === new Date().toDateString();
    }
  },
  mounted: function mounted() {
    this.showApplet();
  }
};